import { render, staticRenderFns } from "./WorkspaceListsTabTemplate.vue?vue&type=template&id=49611e37&"
import script from "./WorkspaceListsTabTemplate.vue?vue&type=script&lang=js&"
export * from "./WorkspaceListsTabTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceListsTabTemplate.vue?vue&type=style&index=0&id=49611e37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports